
   $(document).ready(function(){
      $(".filter_toggle").click(function(){
          $(".facets-vertical").toggleClass("hide_filter");
      });
  });
  document.addEventListener('DOMContentLoaded', function () {
    const resetButton = document.getElementById('reset-filters');

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        const url = new URL(window.location.href);
        url.search = ''; // Clear all filters
        window.location.href = url.toString(); // Reload the page without filters
      });
    }

    const popup = document.querySelector('.product_quote_popup');
    const closeBtn = document.querySelector('.close-quote-popup');
    const smallPopup = document.querySelector(".small_popup_outer");

    // 1️⃣ Show small popup after 5 seconds
    window.addEventListener("load", function () {
      setTimeout(function () {
        if (smallPopup) {
          smallPopup.classList.remove('hidden');
        }
      }, 5000);
    });

    // 2️⃣ Handle all "Request a quote" buttons via event delegation
    document.addEventListener('click', function (e) {
      if (e.target.classList.contains('open-quote-popup')) {
        e.preventDefault();
        if (smallPopup) smallPopup.classList.add('hidden'); // Hide small popup
        if (popup) popup.classList.remove('hidden');        // Show quote popup
      }
    });

    // 3️⃣ Close quote popup on close button click
    if (closeBtn && popup) {
      closeBtn.addEventListener('click', function () {
        popup.classList.add('hidden');
      });

      // Optional: click outside popup to close
      popup.addEventListener('click', function (e) {
        if (e.target === popup) {
          popup.classList.add('hidden');
        }
      });
    }

    
});



$(document).ready(function () {
  // For each media gallery on the page
  $('[id^="GalleryViewer-"]').each(function () {
    var $gallery = $(this);
    var $slides = $gallery.find('.product__media-item');
    var $nextBtn = $gallery.find('.media-nav.next');
    var $prevBtn = $gallery.find('.media-nav.prev');
    var $counterCurrent = $gallery.find('.slider-counter--current');
    var totalSlides = $slides.length;
    var currentIndex = 0;

    function updateGallery(index) {
      // Ensure index stays in bounds
      index = Math.max(0, Math.min(index, totalSlides - 1));
      $slides.removeClass('is-active');
      $slides.eq(index).addClass('is-active');
      $counterCurrent.text(index + 1);
      currentIndex = index;
    }

    $nextBtn.on('click', function () {
      updateGallery(currentIndex + 1);
    });

    $prevBtn.on('click', function () {
      updateGallery(currentIndex - 1);
    });

    // Thumbnail click (optional)
    $('[id^="Slider-Thumbnails-"] .thumbnail-list__item').on('click', function () {
      var targetMediaId = $(this).data('target');
      var index = $slides.index($('#Slide-' + targetMediaId));
      if (index >= 0) {
        updateGallery(index);
      }
    });
  });

   const thumbSwiper = new Swiper('.thumb-slider', {
    slidesPerView: 6,
    spaceBetween: 20,
    breakpoints: {
      0: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 6,
      }
    },
    freeMode: true,
    watchSlidesProgress: true,
  });
  
  const mainSwiper = new Swiper('.main-slider', {
    spaceBetween: 30,
    loop: false,
    navigation: {
      nextEl: '.main-button-next',
      prevEl: '.main-button-prev',
    },
    thumbs: {
      swiper: thumbSwiper,
    },
  });
  
  let popupSwiper; // global so we can destroy and recreate
  
  // Open popup and initialize Swiper
  $('.product-media-slider .main-slider .swiper-slide img').on('click', function () {
    $('.popup_media_slider').addClass('active');
  
    // Find the index of clicked slide (the parent .swiper-slide)
    const clickedIndex = $(this).closest('.swiper-slide').index();
  
    setTimeout(function () {
      if (popupSwiper) {
        popupSwiper.destroy(true, true); // Destroy previous instance if exists
      }
  
      popupSwiper = new Swiper('.media-popup-slider', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: false,
        spaceBetween: 30,
        observer: true,
        observeParents: true,
        initialSlide: clickedIndex,  // <-- Set starting slide here
        navigation: {
          nextEl: '.media-popup-button-next',
          prevEl: '.media-popup-button-prev',
        },
      });
    }, 100);
  });
  
  // Close popup
  $('.popup_media_slider .close_popup').on('click', function () {
    $('.popup_media_slider').removeClass('active');
  });


  
    
  });





